import {Link, useLocation} from 'react-router-dom'

import {ReactComponent as IconMenuHome} from '../../gfx/menu-home.svg'
import {ReactComponent as IconMenuOurMenu} from '../../gfx/menu-our-menu.svg'
import {ReactComponent as IconMenuRewards} from '../../gfx/menu-rewards.svg'
import {ReactComponent as IconMenuReservation} from '../../gfx/menu-reservation.svg'
import {ReactComponent as IconMenuMore} from '../../gfx/menu-more.svg'
import {Col, Row} from 'antd'
import {useEffect} from 'react'

export default function AppMenu({onScreen, activeItem, $auth}) {
  const {pathname} = useLocation()

  useEffect(() => {

  }, [])

  return (
    <div className={`menu-wrapper ${onScreen ? 'active' : ''}`}>
      <nav className="menu">
        <Row justify="space-evenly">
          <Link to="/">
            <Col className={`menu-item ta-center ${pathname === '/' ? 'active' : ''}`}>

              <IconMenuHome/><br/>
              <span className="menu-item-title active">{$auth.isAuthorizedState ? 'Domů' : 'Přihlášení'}</span>

            </Col>
          </Link>
          <Link to="/menu">
            <Col className={`menu-item ta-center ${pathname === '/menu' ? 'active' : ''}`}>

              <IconMenuOurMenu/><br/>
              <span className="menu-item-title">Naše menu</span>

            </Col>
          </Link>

          {
            $auth.isAuthorizedState &&
            <Link to="/rewards">
              <Col className={`menu-item ta-center ${pathname === '/rewards' ? 'active' : ''}`}>

                <IconMenuRewards/><br/>
                <span className="menu-item-title">Odměny</span>

              </Col>
            </Link>
          }

          <Link to="/reservation">
            <Col className={`menu-item ta-center ${pathname === '/reservation' ? 'active' : ''}`}>
              <IconMenuReservation/><br/>
              <span className="menu-item-title">Rezervace</span>

            </Col>
          </Link>
          <Link to="/other">
            <Col className={`menu-item ta-center ${pathname === '/other' ? 'active' : ''}`}>
              <IconMenuMore/><br/>
              <span className="menu-item-title">Více</span>

            </Col>
          </Link>
        </Row>
      </nav>
    </div>
  )
}